import _ from "lodash";

import FillInTheBlank from "slides/templates/FillInTheBlank.react";
import Anagram from "slides/templates/Anagram.react";
import OpenAnswer from "slides/templates/OpenAnswer.react";
import SingleSelect from "slides/templates/SingleSelect.react";
import Rating from "slides/templates/Rating.react";
import FileUploader from "slides/templates/FileUploader.react";
import ScoredMCQ from "slides/templates/ScoredMCQ.react";
import TaggedMCQ from "slides/templates/TaggedMCQ.react";
import TrueFalse from "slides/templates/TrueFalse.react";
import MultipleSelect from "slides/templates/MultipleSelect.react";
import PickPicture from "slides/templates/PickPicture.react";
import RangeSelect from "slides/templates/RangeSelect.react";
import Qualification from "slides/templates/Qualification.react";
import Brancher from "slides/templates/Brancher.react";
import ResponseField from "slides/templates/ResponseField.react";
import Title from "slides/templates/Title.react";
import Paragraph from "slides/templates/Paragraph.react";
import ImageStory from "slides/templates/ImageStory.react";
import VideoStory from "slides/templates/VideoStory.react";

const TemplateList = {
    title: {
        key: "title",
        name: "Title",
        template: Title,
        questionable: false,
        scorable: false,
        interaction: "",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: true,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: false },
        components: ["background", "image", "title"],
    },
    paragraph: {
        key: "paragraph",
        name: "Paragraph",
        template: Paragraph,
        questionable: false,
        scorable: false,
        interaction: "",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: true,
            submission: false,
            linklist: false,
        },
        audit: { verbose: true, visual: false, interactive: false },
        components: ["background", "title", "paragraph"],
    },
    image_story: {
        key: "image_story",
        name: "Captioned Image",
        template: ImageStory,
        questionable: false,
        scorable: false,
        interaction: "",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: true,
            submission: false,
            linklist: false,
        },
        audit: { verbose: true, visual: false, interactive: false },
        components: ["background", "title", "image", "caption"],
    },
    video_story: {
        key: "video_story",
        name: "Captioned Video",
        template: VideoStory,
        questionable: false,
        scorable: false,
        interaction: "",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: true,
            submission: false,
            linklist: false,
        },
        audit: { verbose: true, visual: false, interactive: false },
        components: ["background", "title", "video", "caption"],
    },

    input_field: {
        key: "input_field",
        name: "Input Field",
        template: ResponseField,
        questionable: true,
        scorable: false,
        interaction: "openAnswer",
        target: {
            quiz: false,
            assessment: true,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: true,
            poll: false,
            feedback: true,
            story: false,
            submission: true,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "question"],
    },
    true_false: {
        key: "true_false",
        name: "Binary Choice",
        template: TrueFalse,
        questionable: true,
        scorable: true,
        interaction: "trueFalse",
        target: {
            quiz: true,
            assessment: true,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: true,
            survey: true,
            poll: false,
            feedback: false,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "weight", "question", "choice", "feedback"],
    },
    single_select: {
        key: "single_select",
        name: "Single Select",
        template: SingleSelect,
        questionable: true,
        scorable: true,
        interaction: "singleSelect",
        target: {
            quiz: true,
            assessment: true,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: true,
            survey: true,
            poll: true,
            feedback: false,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "weight", "question", "options", "feedback"],
    },
    pick_picture: {
        key: "pick_picture",
        name: "Picture Select",
        template: PickPicture,
        questionable: true,
        scorable: true,
        interaction: "singleSelect",
        target: {
            quiz: true,
            assessment: true,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: true,
            survey: true,
            poll: false,
            feedback: false,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: true, interactive: true },
        components: ["image", "weight", "question", "imageOpts", "feedback"],
    },
    multiple_select: {
        key: "multiple_select",
        name: "Multiple Select",
        template: MultipleSelect,
        questionable: true,
        scorable: true,
        interaction: "multiSelect",
        target: {
            quiz: true,
            assessment: true,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: true,
            poll: false,
            feedback: false,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "weight", "question", "multiselect", "feedback"],
    },
    rating: {
        key: "rating",
        name: "Rating",
        template: Rating,
        questionable: true,
        scorable: true,
        interaction: "rating",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: true,
            poll: false,
            feedback: true,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "question", "rating"],
    },
    scored_single_select: {
        key: "scored_single_select",
        name: "Scored Question",
        template: ScoredMCQ,
        questionable: true,
        scorable: true,
        interaction: "scoreSelect",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            recommendation: false,
            game: false,
            survey: false,
            poll: false,
            feedback: true,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "question", "scoreselect"],
    },
    tagged_select: {
        key: "tagged_select",
        name: "Tagged Question",
        template: TaggedMCQ,
        questionable: true,
        scorable: false,
        interaction: "taggedSelect",
        target: {
            quiz: false,
            assessment: false,
            profiler: true,
            calculator: false,
            recommendation: true,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "question", "taggedselect"],
    },
    range_select: {
        key: "range_select",
        name: "Calculation",
        template: RangeSelect,
        questionable: true,
        scorable: false,
        interaction: "rangeSelect",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            recommendation: false,
            calculator: true,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "question", "rangeselect", "formula"],
    },
    qualification: {
        key: "qualification",
        name: "Measured Result",
        template: Qualification,
        questionable: true,
        scorable: true,
        interaction: "qualification",
        target: {
            quiz: false,
            assessment: true,
            profiler: false,
            recommendation: false,
            calculator: false,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "weight", "question", "rangeselect", "criteria"],
    },
    fill_in_the_blanks: {
        key: "fill_in_the_blanks",
        name: "Fill in the Blanks",
        template: FillInTheBlank,
        questionable: true,
        scorable: true,
        interaction: "fillInTheBlank",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "weight", "question", "answer", "feedback"],
    },
    uploader: {
        key: "uploader",
        name: "File Uploader",
        template: FileUploader,
        questionable: true,
        scorable: false,
        interaction: "uploader",
        target: {
            quiz: false,
            assessment: true,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: false,
            submission: true,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "question", "button"],
    },
    anagram: {
        key: "anagram",
        name: "Anagram",
        template: Anagram,
        questionable: true,
        scorable: true,
        interaction: "fillInTheBlank",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: false,
            submission: false,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "question", "answer", "feedback"],
    },
    brancher: {
        key: "brancher",
        name: "Link List",
        template: Brancher,
        questionable: true,
        scorable: false,
        interaction: "brancher",
        target: {
            quiz: false,
            assessment: false,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: false,
            poll: false,
            feedback: false,
            story: false,
            submission: false,
            linklist: true,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "question", "popupitems"],
    },
    open_answer: {
        key: "open_answer",
        name: "Open Answer",
        template: OpenAnswer,
        questionable: true,
        scorable: false,
        interaction: "openAnswer",
        target: {
            quiz: false,
            assessment: true,
            profiler: false,
            calculator: false,
            recommendation: false,
            game: false,
            survey: true,
            poll: false,
            feedback: true,
            story: false,
            submission: true,
            linklist: false,
        },
        audit: { verbose: false, visual: false, interactive: true },
        components: ["image", "question"],
    },
};

const trackInteractionCase = (slideData, response) => {
    let options;
    let interactionType = TemplateList[slideData.template].interaction;
    switch (interactionType) {
        case "singleSelect":
            options =
                slideData.data.options ||
                slideData.data.imageOpts ||
                slideData.data.images;
            return {
                correct: options[response]["correct"] === "checked",
                response: response,
            };
        case "scoreSelect":
            options = slideData.data.scoreselect;
            return {
                correct: true,
                value: options[response].option,
                response: response,
            };
        case "taggedSelect":
            options = slideData.data.taggedselect;
            return {
                correct: true,
                value: options[response].tags,
                response: response,
            };
        case "trueFalse":
            options = slideData.data.choice;
            return {
                correct: options[response]["correct"] === "checked",
                response: response,
            };
        case "fillInTheBlank":
            let givenAnswer = response.trim().toLowerCase(),
                correctAns = slideData.data.answer
                    .toString()
                    .trim()
                    .toLowerCase();
            return {
                correct: givenAnswer === correctAns,
                response: response,
            };
        case "multiSelect":
            options = slideData.data.multiselect;
            let correctCount = _.filter(options, ["correct", "checked"]),
                allCorrect = true;
            _.map(response, (item) => {
                if (options[item]["correct"] !== "checked") allCorrect = false;
            });
            return {
                correct: allCorrect && response.length === correctCount.length,
                response: response,
            };
        case "rankThem":
            options = slideData.data.bullets;
            return {
                correct: _.isEqual(options, response),
                response: response,
            };
        case "qualification":
            return {
                correct: response.correct,
                response: response.response,
            };
        case "openAnswer":
        case "rangeSelect":
        case "uploader":
        case "rating":
        case "brancher":
            return { correct: null, response: response };
        default:
    }
};

const freeAccess = [
    "survey",
    "poll",
    "feedback",
    "assessment",
    "audit",
    "submission",
    "story",
];
const nonScorables = [
    "survey",
    "poll",
    "feedback",
    "submission",
    "linklist",
    "calculator",
    "story",
];
const nonFeedbackables = [
    "survey",
    "poll",
    "feedback",
    "submission",
    "linklist",
    "calculator",
    "assessment",
    "story",
];
const nonResultable = [
    "survey",
    "feedback",
    "linklist",
    "calculator",
    "submission",
];
const singleSlider = ["poll", "linklist", "calculator", "game"];
const nonLeadable = ["linklist", "calculator"];
const uploadable = [
    "quiz",
    "survey",
    "game",
    "audit",
    "assessment",
    "profiler",
    "recommendation",
];

const scorableTemplates = _.map(
    _.filter(_.values(TemplateList), (template) => template.scorable),
    "key"
);

export {
    TemplateList,
    trackInteractionCase,
    nonScorables,
    nonFeedbackables,
    nonResultable,
    uploadable,
    nonLeadable,
    freeAccess,
    singleSlider,
    scorableTemplates,
};
